import * as v from 'valibot';
export function checkBetween(min, max) {
    return v.check((n) => n >= min && n <= max, 'Must be between ' + min + ' and ' + max);
}
export function integerInRange(min, max) {
    return v.pipe(v.number(), v.safeInteger(), checkBetween(min, max));
}
export const nwkSchema = integerInRange(0, 0xffff);
export const ieeeSchema = v.pipe(v.string(), v.regex(/^[0-9a-f]{16}$/, 'Expected ieee as hex string (without 0x)'));
export const attributeIdSchema = integerInRange(0, 0xffff);
export const endpointIdSchema = integerInRange(0, 0xff);
export const clusterIdSchema = integerInRange(0, 0xffff);
export const hex16Schema = v.pipe(v.string(), v.hexadecimal(), v.transform((s) => parseInt(s, 16)), checkBetween(0, 0xffff));
export const groupIdSchema = v.pipe(v.string(), v.hexadecimal(), v.transform((s) => parseInt(s, 16)), checkBetween(0, 0xffff));
export const dateStringSchema = v.pipe(v.string(), v.isoTimestamp(), v.toDate(), v.transform((s) => s.toISOString()));
/*
// construct a new schema for an object with these keys and unknown values
export const keysOnly = <T extends Record<string, v.GenericSchema>>(
    schema: { entries: T }
) =>
    v.object(
        Object.fromEntries(
            Object.keys(schema.entries).map((k) => [k, v.unknown()])
        ) as { [K in keyof T]: v.UnknownSchema }
    );
*/
const ABSENT_OK = new Set(['optional', 'nullish', 'undefinedable', 'exactOptional']);
// every non-optional key is required
const requiredKeys = (schema) => Object.keys(schema.entries).filter((k) => !ABSENT_OK.has(schema.entries[k].type));
// runtime check to see if an unknown input is an object with at least these keys
export const hasAtLeastKeys = (schema, input) => {
    if (typeof input !== 'object' || input === null) {
        return false;
    }
    return requiredKeys(schema).every((k) => k in input);
};
// runtime check to see if an unknown input is an object with excact these keys
export const hasExactKeys = (schema, input) => {
    if (!hasAtLeastKeys(schema, input))
        return false;
    const allowed = new Set(Object.keys(schema.entries));
    return Object.keys(input).every((k) => allowed.has(k));
};
// an attemp to make union errors bettern by picking the best potential error
// Use it like: v.summarize(collapseUnions(result.issues));
const pickBest = (issues) => issues.reduce((a, b) => { var _a, _b, _c, _d; return ((_b = (_a = a.issues) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) <= ((_d = (_c = b.issues) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) ? a : b; });
export const collapseUnions = (issues) => issues.map((i) => { var _a; return i.type === 'union' && ((_a = i.issues) === null || _a === void 0 ? void 0 : _a.length) ? pickBest(i.issues) : i; });
